(() => {
  const config = window.viCheckoutIntercept;
  if (!config?.enabled || !config.destination) return;

  const delayMs = Number(config.delayMs) || 300;
  const cartEndpoint = `${window.routes?.cart_url || '/cart'}.js`;
  let redirectInFlight = false;

  const toAbsoluteUrl = (value) => {
    try {
      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  };

  const checkoutPathMatches = (value) => {
    const url = toAbsoluteUrl(value);
    if (!url) return false;

    return /\/checkout\/?$/.test(url.pathname);
  };

  const normalizeTitles = (items = []) => {
    const seen = new Set();

    return items
      .map((item) => item?.product_title || item?.title || '')
      .map((title) => title.trim())
      .filter((title) => {
        if (!title || seen.has(title)) return false;
        seen.add(title);
        return true;
      });
  };

  const buildFallbackUrl = () => {
    const destinationUrl = toAbsoluteUrl(config.destination);
    if (!destinationUrl) return null;

    destinationUrl.searchParams.set('p0', 'product');
    destinationUrl.searchParams.set('count', '1');
    return destinationUrl.toString();
  };

  const buildRedirectUrl = (cart) => {
    const destinationUrl = toAbsoluteUrl(config.destination);
    if (!destinationUrl) return null;

    const titles = normalizeTitles(cart?.items);
    const itemCount = Number(cart?.item_count) || titles.length || 1;

    if (!titles.length) {
      destinationUrl.searchParams.set('p0', 'product');
      destinationUrl.searchParams.set('count', String(itemCount));
      return destinationUrl.toString();
    }

    titles.forEach((title, index) => {
      destinationUrl.searchParams.set(`p${index}`, title);
    });
    destinationUrl.searchParams.set('count', String(itemCount));

    return destinationUrl.toString();
  };

  const trackInitiateCheckout = (cart) => {
    if (typeof window.fbq !== 'function' || !cart) return;

    const items = Array.isArray(cart.items) ? cart.items : [];
    const contents = items.map((item) => {
      const quantity = Number(item.quantity) || 0;
      const linePrice = Number(item.final_line_price ?? item.line_price ?? 0);
      const itemPrice = quantity > 0 ? linePrice / quantity / 100 : 0;

      return {
        id: item.product_id || item.id,
        quantity,
        item_price: itemPrice
      };
    });

    window.fbq('track', 'InitiateCheckout', {
      content_ids: items.map((item) => item.product_id || item.id).filter(Boolean),
      contents,
      content_type: 'product',
      num_items: Number(cart.item_count) || contents.reduce((total, item) => total + item.quantity, 0),
      value: Number(cart.total_price || 0) / 100,
      currency: config.currency || 'EUR'
    });
  };

  const fetchCart = async () => {
    const response = await fetch(cartEndpoint, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Cart request failed with status ${response.status}`);
    }

    return response.json();
  };

  const redirectToWaitlist = async () => {
    if (redirectInFlight) return;
    redirectInFlight = true;

    let redirectUrl = buildFallbackUrl();

    try {
      const cart = await fetchCart();
      trackInitiateCheckout(cart);
      redirectUrl = buildRedirectUrl(cart) || redirectUrl;
    } catch (error) {
      console.warn('Checkout intercept fallback activated.', error);
    }

    window.setTimeout(() => {
      if (redirectUrl) {
        window.location.assign(redirectUrl);
        return;
      }

      redirectInFlight = false;
    }, delayMs);
  };

  const shouldInterceptSubmit = (form, submitter) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.closest('[data-no-checkout-intercept]')) return false;

    if (submitter && submitter.name === 'checkout') return true;

    const action = form.getAttribute('action') || '';
    return checkoutPathMatches(action);
  };

  const shouldInterceptClick = (target) => {
    if (!(target instanceof Element)) return false;
    if (target.closest('[data-no-checkout-intercept]')) return false;

    const link = target.closest('a[href]');
    if (link && checkoutPathMatches(link.getAttribute('href') || '')) return true;

    const button = target.closest('button[name="checkout"], input[name="checkout"]');
    return Boolean(button && !button.form);
  };

  document.addEventListener(
    'submit',
    (event) => {
      if (!shouldInterceptSubmit(event.target, event.submitter)) return;

      event.preventDefault();
      redirectToWaitlist();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!shouldInterceptClick(event.target)) return;

      event.preventDefault();
      redirectToWaitlist();
    },
    true
  );
})();
